export default __webpack_public_path__ + "static/media/trello.928ecd0e.svg";